import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { GetTenantAccountQuery, TenantAccount } from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const QUERY_TENANT_ACCOUNT_BY_ID = gql`
  query getTenantAccountById {
    account {
      id
      createdAt
      country
      email
      defaultCurrency
      payFacType
      acceptedPaymentMethods
      owner {
        tenantId
      }
      payfac {
        ids {
          resourceId
          resourceType
        }
      }
      company {
        name
        phone {
          countryCode
          number
        }
        address {
          city
          country
          line1
          line2
          postalCode
          region
        }
        verification {
          status
        }
      }
      businessProfile {
        name
        supportEmail
      }
      tosAcceptance {
        date
      }
      settings {
        supportedPaymentMethods
        features {
          creditMemos {
            enabled
          }
          customers {
            enabled
          }
          paymentMethods {
            autoUpdate
            paymentMethodRequests
          }
          payments {
            convenienceFees
            virtualTerminal
          }
          paymentRequests {
            consolidatedPayment
            partialPayment
            paymentReminderEmails
          }
          customEmailSettings {
            enabled
          }
        }
        cardPayments {
          refundPolicy
          statementDescription
        }
      }
    }
  }
`;

export const queryTenantAccountById = async (
  client: ApolloClient<NormalizedCacheObject>,
  tenantId: string,
): Promise<TenantAccount | undefined> => {
  const baseHeaders = await getStandardHeaders(true);
  const headers = { ...baseHeaders, 'x-aptean-tenant': tenantId };
  const { data, errors } = await client.query<GetTenantAccountQuery>({
    query: QUERY_TENANT_ACCOUNT_BY_ID,
    context: { headers },
    fetchPolicy: 'network-only',
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the query.');
  }
  return data?.account as TenantAccount;
};
